export const ReferralContactStatus = {
  PENDING: 'pending',
  VERIFIED: 'verified',
  CANCELLED: 'cancelled',
};
